export default __webpack_public_path__ + "static/media/fun and games.3e029ba3.png";